import { object, number, string } from '@gogame/schemas';

import { APPLICATION, PROTOTYPE_ID } from './constants';

export const eventSchema = object({
  [APPLICATION]: number().required('Application is required'),
  [PROTOTYPE_ID]: string().required('Trigger is required'),
});
